// Misc
import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'

// Constants
import { INTEGRATION_MAILCHIMP_CONNECTED } from 'constants/redirectEvents'

// Utils
import { RegisterEventRedirectOnClick } from 'utils/eventRedirect'

// Selectors
import { connectGetters } from 'react-redux-getters'
import { isMailChimpConnected } from 'selectors/integrations'

// Atoms
import Spacer from 'atoms/Spacer'
import Warning from 'atoms/Warning'
import { StyledLink } from 'atoms/Link'
import FieldLayout from '../FieldLayout'

const mapGettersToProps = state => ({
  isMailChimpConnectedGetter: isMailChimpConnected(state)
})

export default
@connectGetters(mapGettersToProps)
class NewsletterSubscribeEditor extends Component {
  static propTypes = {
    onDelete: PropTypes.func.isRequired,
    isMailChimpConnectedGetter: PropTypes.object.isRequired,
  }

  handleDelete = () => {
    const { onDelete } = this.props
    onDelete()
  }

  render() {
    const { isMailChimpConnectedGetter } = this.props
    return (
      <Fragment>
        <Spacer />
        <FieldLayout title="Subscribe to newsletter" onDelete={this.handleDelete}>
          { !isMailChimpConnectedGetter.data && (
            <Warning>
              Connect MailChimp account
              {' '}
              <RegisterEventRedirectOnClick
                event={INTEGRATION_MAILCHIMP_CONNECTED}
                component={StyledLink}
                to="/integrations"
              >
                here
              </RegisterEventRedirectOnClick>
              {' '}
              to enable this option
            </Warning>
          ) }
        </FieldLayout>
      </Fragment>
    )
  }
}
